// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"1cda883a","590":"7909d0c7","787":"a4119fe8","909":"a93cba7d"}[chunkId] + ".chunk.js";
};